import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UIModule } from '@c4/ui';

@Component({
  selector: 'sysman-network-config-ip',
  templateUrl: './ip-config.component.html'
})
export class SysmanNetworkConfigIPComponent {

  @Input() name: string;
  @Input() tagId: string;
  @Input() type: string;
  @Input() address: string;
  @Input() netmask: string;
  @Input() gateway: string;

  @Output() valueChangeType: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChangeAddress: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChangeNetmask: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChangeGateway: EventEmitter<string> = new EventEmitter<string>();

  IPOptions : Array<any> = [{name:"Obtain Automatically with DHCP",value:"dhcp"},{name:"Use a Static IP Address",value:"static"}];

  constructor() { 
  }

}


// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-network-config/ip-config.component.ts